<template>
  <PayOpsModalShell
    :visible="visible"
    title="Force Complete"
    subtitle="Bypasses normal state guards and records the override"
    icon="fa-shield"
    tone="warning"
    size="md"
    :close-disabled="isSubmitting"
    @close="$emit('close')"
  >
    <div class="alert alert-warning outline small">
      <i class="fa fa-exclamation-triangle me-1"></i>
      <strong>Force Complete</strong> bypasses the normal state guards. This action forces the order
      into COMPLETED_MANUALLY regardless of its current state. The force flag is recorded in the
      audit log.
    </div>

    <div class="mb-3">
      <label class="form-label fw-bold"
        >Reason <span class="text-danger">*</span> (min 10 chars)</label
      >
      <textarea
        v-model="reason"
        class="form-control border border-primary"
        rows="3"
        placeholder="Explain why force complete is necessary..."
      ></textarea>
      <div class="form-text">Characters: {{ reason.length }} / 10 minimum</div>
    </div>

    <div class="form-check mb-3">
      <input
        v-model="acknowledged"
        type="checkbox"
        class="form-check-input border border-primary"
        id="forceAck"
      />
      <label class="form-check-label" for="forceAck">
        I acknowledge that this action bypasses normal state guards and will be recorded in the
        audit log.
      </label>
    </div>
    <template #footer>
      <button class="btn btn-outline-secondary" :disabled="isSubmitting" @click="$emit('close')">
        Cancel
      </button>
      <button class="btn btn-warning" :disabled="!canSubmit || isSubmitting" @click="submit">
        <span v-if="isSubmitting">
          <span class="spinner-border spinner-border-sm me-1"></span>Processing...
        </span>
        <span v-else><i class="fa fa-check-circle me-1"></i>Force Complete</span>
      </button>
    </template>
  </PayOpsModalShell>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import PayOpsModalShell from '../../shared/PayOpsModalShell.vue';

const props = defineProps({
  visible: { type: Boolean, default: false },
  isSubmitting: { type: Boolean, default: false },
});
const emit = defineEmits(['close', 'submit']);

const reason = ref('');
const acknowledged = ref(false);

const canSubmit = computed(() => reason.value.length >= 10 && acknowledged.value);

watch(
  () => props.visible,
  (v) => {
    if (v) {
      reason.value = '';
      acknowledged.value = false;
    }
  },
);

function submit() {
  if (!canSubmit.value) return;
  emit('submit', { reason: reason.value, reasonCategory: 'forceComplete' });
}
</script>
